<kendo-dialog title="{{'_Report_Filter_Save_As_Template_Popup_Title_' | translate }}" *ngIf="saveAsDialogOpened" [minWidth]="300" [width]="500"
  (close)="close()" class="cc-dialog-sm">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>

  <div class="mb-3">
    {{'_Report_Filters_Save_As_Popup_Description_Text_' | translate }}
  </div>

  <div>
      <label>{{'_Report_Filters_Template_Name_Text_' | translate }} <span tabindex="-1" class="required-field">*</span></label>
      <input class="form-control" #saveAsName maxlength="200" type="text" name="saveAsName" [(ngModel)]="result.name"
        placeholder="{{'_Report_Filters_Template_Name_Text_' | translate }}" id="templateName" (keyup)="nameChanged($event)" app-no-lead-ws app-filter
        pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">
  </div>

  <div class="cc-validation">
    <div *ngIf="templateNameInUse">
      {{'_Report_Filters_Template_Name_In_Use_Error_Text_' | translate }}
    </div>
    <div *ngIf="templateNameRequired">
      {{'_Report_Filters_Template_Name_Is_Required_Error_Text_' | translate }}
    </div>
  </div>

  <kendo-dialog-actions class="cc-btn-panel">
    <button id="saveAsFilterTempCancelBtn" class="btn btn-secondary" (click)="clickCancel()" [disabled]="false">{{'_General_Button_Cancel_Text_' | translate }}</button>
    <button id="saveAsFilterTempSaveBtn" class="btn btn-primary" (click)="clickSaveAs()" [disabled]="saveDisabled">{{'_Report_Filters_Save_New_Template_Button_Text_' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
